module.exports = __webpack_public_path__ + "static/media/upsell-targeting.705f1e34.png";